import { Loader2, Wand2 } from "lucide-react";

// Segment math from the preview endpoint: {chars, encoding, segments, per_segment, non_gsm, fixable, emoji}
export const SmsMeter = ({ meta, onNormalize, normalizing }) => {
  if (!meta || meta.segments === undefined) return null;
  const uni = meta.encoding === "ucs2";
  const fixable = uni && (meta.fixable || []).length > 0;
  const emoji = uni && (meta.emoji || []).length > 0;
  return (
    <div data-testid="sms-meter" className={`mt-1.5 flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] ${uni ? "text-amber-700" : meta.segments > 1 ? "text-ink/60" : "text-ink/45"}`}>
      <span data-testid="sms-segments">
        <strong>{meta.segments}</strong> text segment{meta.segments === 1 ? "" : "s"} · {meta.chars} chars · {uni ? "Unicode" : "GSM-7"}
      </span>
      {emoji && <span data-testid="sms-emoji-note">Emoji ({meta.emoji.join(" ")}) cuts each segment to {meta.per_segment} characters</span>}
      {fixable && !emoji && <span>Smart quotes or dashes are forcing Unicode</span>}
      {fixable && (
        <button type="button" data-testid="sms-normalize" onClick={onNormalize} disabled={normalizing}
          className="inline-flex items-center gap-1 rounded-full border border-amber-300 bg-white px-2 py-0.5 font-semibold hover:bg-amber-50 disabled:opacity-50">
          {normalizing ? <Loader2 className="h-3 w-3 animate-spin" /> : <Wand2 className="h-3 w-3" />} Use plain quotes & dashes
        </button>
      )}
      {meta.segments > 3
        ? <span data-testid="sms-long-note" className="font-semibold text-amber-700">Long — each segment counts toward the monthly text allowance; aim for 3 or fewer</span>
        : !uni && meta.segments > 1 && <span>Each segment counts as one text</span>}
    </div>
  );
};
